import React, { useState } from "react";
import { useAuthUserContext } from "../../context/UserContext";
import { Link } from "react-router-dom";
import useQuery from "../../hooks/useQuery";

import styles from "./LoginPage.module.css";
import PageHeader from "../App/PageHeader";
import ContentSection from "../App/ContentSection";
import Button from "../UserInterfaceElements/Button";
import ButtonGroup from "../UserInterfaceElements/ButtonGroup";
import DarkPage from "../UserInterfaceElements/DarkPage";

const LoginPage: React.FC = () => {
  const [password, setPassword] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const { error, login /*, user */ } = useAuthUserContext();
  const redirectUrl = useQuery("redirect");

  const doLogin = async () => {
    //console.log("trying to login", email, password);
    if ( (!email ) || (!password)) {
      return;
    }
    try {
      login(email, password, redirectUrl);
    } catch (ex) {}
  };

  return (<DarkPage>
    <div className={styles.LoginPage}>
      <PageHeader>Login</PageHeader>
      <ContentSection>
      {error && <p>{error}</p>}
        <div className={styles.LoginForm}>
          <input
            className={styles.EmailInput}
            placeholder="email"
            value={email}
            onChange={(evt) => setEmail(evt.target.value)}
          />
          <input
            className={styles.PasswordInput}
            placeholder="password"
            value={password}
            type="password"
            onChange={(evt) => setPassword(evt.target.value)}
          />
          <Link className={styles.ForgotPasswordLink} to={`/password/forgot`}>
            Forgot password?
          </Link>
          <ButtonGroup layout="horizontal">
            <Button
              to={`/signup${redirectUrl ? `?redirect=${redirectUrl}` : ""}`}
              altStyle={true}
            >
              Sign Up
            </Button>
            <Button onClick={doLogin}>Login</Button>
          </ButtonGroup>
        </div>
      </ContentSection>
    </div></DarkPage>
  );
};

export default LoginPage;
